import { Component, OnInit } from '@angular/core';
import { OccurrenceApiService } from '../../services/api/occurrence-api.service';
import { ReturnPackageApiService } from '../../services/api/return-package.service';
import { UiRouterState } from '../../services/ajs-router-state.service';
import { TicketApiService } from '../../services/api/ticket-api.service';

@Component({
  selector: 'mandae-home-counters',
  templateUrl: './counters.component.html',
  styleUrls: ['./counters.component.scss']
})
export class CountersComponent implements OnInit {

  public valores = 0;

  public counters = [{
    id: 'ocorrencias_pendentes',
    svgIcon: 'packages:incident',
    count: 0,
    label: 'Ocorrências pendentes',
    onClick: () => this.state.go('packages-list', { acoesPendentes: true })
  }, {
    id: 'em_atraso',
    matIcon: 'access_time',
    count: 0,
    label: 'Em atraso',
    onClick: () => this.state.go('packages-list', { emAtraso: true })
  }, {
    id: 'em_devolucao',
    svgIcon: 'packages:return',
    count: 0,
    label: 'Em devolução',
    onClick: () => this.state.go('devolucoes')
  }, {
    id: 'solicitacoes_em_aberto',
    svgIcon: 'menu:chat',
    count: 0,
    label: 'Solicitações em aberto',
    onClick: () => this.state.go('relacionamento')
  }];

  constructor(private state: UiRouterState,
              private occurrenceApiService: OccurrenceApiService,
              private returnPackageApiService: ReturnPackageApiService,
              private ticketApiService: TicketApiService) { }

  async ngOnInit() {

    const totalAtrasados = await this.occurrenceApiService.getDelayedCount();
    this.counters.find(c => c.id === 'em_atraso').count = totalAtrasados.encomendasAtrasadas;

    const totalRequest = await this.occurrenceApiService.getTotals();
    const valorPendentes = totalRequest.acoesPendentes.emProcessamento + totalRequest.acoesPendentes.enviadas;
    this.counters.find(c => c.id === 'ocorrencias_pendentes').count = valorPendentes;

    const totalNaoEncontradas = await this.occurrenceApiService.getNaoEncontradas();
    const lastValor = this.counters.find(c => c.id === 'ocorrencias_pendentes').count;
    this.counters.find(c => c.id === 'ocorrencias_pendentes').count = lastValor + totalNaoEncontradas.naoEncontradas;

    this.returnPackageApiService.getReturnPackages({
      status: [
        'EmDevolucaoParaRemetente',
        'EmDevolucao',
      ],
      limit: 1,
      offset: 0,
    }).subscribe(response => {
      this.counters.find(c => c.id === 'em_devolucao').count = response.count;
    });

    // Chamada otimizada - usa endpoint específico para contador com cache
    this.ticketApiService.getTicketCounter('open').subscribe(response => {
      this.counters.find(c => c.id === 'solicitacoes_em_aberto').count = response.total;
    });
   }

}
